import { jsx as _jsx } from "react/jsx-runtime";
import { Box, IconButton, TextField, } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '../icons/SearchIcon';
const SearchEntryField = ({ searchTerm, setSearchTerm }) => (_jsx(Box, { display: "flex", justifyContent: "flex-end", children: _jsx(TextField, { size: "small", placeholder: "Search...", value: searchTerm, onKeyDown: (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                // handleSearchAndHighlight();
            }
        }, onChange: (event) => { setSearchTerm(event.target.value); }, sx: {
            textAlign: 'right', // Align the text field to the right
        }, InputProps: {
            startAdornment: (_jsx(IconButton, { style: {
                    padding: 5,
                    justifyContent: 'normal',
                    fontSize: 20,
                    borderWidth: '10px',
                    color: '#1976d2',
                }, children: _jsx(SearchIcon, {}) })),
            endAdornment: (_jsx(IconButton, { onClick: () => { setSearchTerm(''); }, disabled: searchTerm === '', children: _jsx(ClearIcon, { fontSize: "small" }) })),
        } }) }));
export default SearchEntryField;
//# sourceMappingURL=SearchEntryField.js.map